// src/components/authentication-options/authentication-options.tsx
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragment on Mark {\n    url {\n      value\n    }\n    description\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment UIActionFragment on UIAction {\n    ... on UILinkAction {\n      resource {\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment UIPrimaryButtonFragment on UIPrimaryButton {\n    accessibility\n    primary\n    action {\n      ...UIActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment UISecondaryButtonFragment on UISecondaryButton {\n    accessibility\n    primary\n    action {\n      ...UIActionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  query AuthenticationOptionsQuery($context: ContextInput!) {\n    travelAgentAuthenticationOptions(context: $context) {\n      logo {\n        ...MarkFragment\n      }\n      title\n      subtitle\n      joinNow {\n        ...UISecondaryButtonFragment\n      }\n      signIn {\n        ...UIPrimaryButtonFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkCard } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/components/authentication-options/__private/__fragments/mark.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment = gql(_templateObject());
var Mark = function(param) {
    var data = param.data;
    var _data_url;
    return /* @__PURE__ */ React.createElement(UitkMark, {
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value,
        size: 9,
        description: data.description
    });
};
Mark.fragment = fragment;
Mark.displayName = "Mark";
// src/components/authentication-options/__private/__fragments/ui-primary-button.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton } from "uitk-react-button";
// src/components/authentication-options/__private/__fragments/ui-action.ts
import { gql as gql2 } from "@apollo/client";
var __UIActionFragment = gql2(_templateObject1());
var getUILinkAction = function(data) {
    var result;
    if (data.__typename === "UILinkAction") {
        var relativePath;
        if (data.resource.__typename === "HttpURI") {
            relativePath = data.resource.relativePath;
        }
        result = {
            href: relativePath,
            analytics: data.analytics
        };
    }
    return result;
};
// src/components/authentication-options/__private/__fragments/ui-primary-button.tsx
var fragment2 = gql3(_templateObject2(), __UIActionFragment);
var UIPrimaryButton = function(param) {
    var data = param.data, className = param.className;
    var _linkAction;
    var track = useClickTracker();
    var linkAction = data.action && getUILinkAction(data.action);
    var onClick = React2.useCallback(function() {
        var _linkAction;
        if ((_linkAction = linkAction) === null || _linkAction === void 0 ? void 0 : _linkAction.analytics) {
            track(linkAction.analytics.referrerId, linkAction.analytics.linkName);
        }
    }, [
        linkAction
    ]);
    var _data_accessibility;
    return ((_linkAction = linkAction) === null || _linkAction === void 0 ? void 0 : _linkAction.href) ? /* @__PURE__ */ React2.createElement(UitkPrimaryButton, {
        href: linkAction.href,
        onClick: onClick,
        "aria-label": (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0,
        className: className
    }, data.primary) : null;
};
UIPrimaryButton.fragment = fragment2;
UIPrimaryButton.displayName = "UIPrimaryButton";
// src/components/authentication-options/__private/__fragments/ui-secondary-button.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
var fragment3 = gql4(_templateObject3(), __UIActionFragment);
var UISecondaryButton = function(param) {
    var data = param.data, className = param.className;
    var _linkAction;
    var track = useClickTracker2();
    var linkAction = data.action && getUILinkAction(data.action);
    var onClick = React3.useCallback(function() {
        var _linkAction;
        if ((_linkAction = linkAction) === null || _linkAction === void 0 ? void 0 : _linkAction.analytics) {
            track(linkAction.analytics.referrerId, linkAction.analytics.linkName);
        }
    }, [
        linkAction
    ]);
    var _data_accessibility;
    return ((_linkAction = linkAction) === null || _linkAction === void 0 ? void 0 : _linkAction.href) ? /* @__PURE__ */ React3.createElement(UitkSecondaryButton, {
        href: linkAction.href,
        onClick: onClick,
        "aria-label": (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0,
        className: className
    }, data.primary) : null;
};
UISecondaryButton.fragment = fragment3;
UISecondaryButton.displayName = "UISecondaryButton";
// src/components/authentication-options/authentication-options.tsx
var __Query = gql5(_templateObject4(), Mark.fragment, UIPrimaryButton.fragment, UISecondaryButton.fragment);
var AuthenticationOptions = function(props) {
    var _data;
    var skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !((_data = data) === null || _data === void 0 ? void 0 : _data.travelAgentAuthenticationOptions)) {
        return null;
    }
    var markFragment = data.travelAgentAuthenticationOptions.logo;
    var signInFragment = data.travelAgentAuthenticationOptions.signIn;
    var joinNowFragment = data.travelAgentAuthenticationOptions.joinNow;
    var subheading = data.travelAgentAuthenticationOptions.subtitle;
    return /* @__PURE__ */ React4.createElement(UitkSpacing, {
        padding: {
            blockstart: "six",
            blockend: "six",
            inline: "twelve"
        }
    }, /* @__PURE__ */ React4.createElement(UitkCard, {
        border: true,
        padded: false
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React4.createElement(Mark, {
        data: markFragment
    })), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        maxWidth: "70x"
    }, /* @__PURE__ */ React4.createElement(UitkHeading, {
        align: "center",
        size: 5,
        tag: "h1"
    }, data.travelAgentAuthenticationOptions.title)), subheading ? /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        maxWidth: "70x"
    }, /* @__PURE__ */ React4.createElement(UitkText, {
        align: "center",
        weight: "regular"
    }, subheading)) : null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        space: "two",
        wrap: "wrap"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React4.createElement(UISecondaryButton, {
        data: joinNowFragment
    })), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
        grow: 1
    }, /* @__PURE__ */ React4.createElement(UIPrimaryButton, {
        data: signInFragment
    })))))));
};
AuthenticationOptions.displayName = "sharedui-AuthenticationOptions";
export { AuthenticationOptions };
//# sourceMappingURL=index.js.map